import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { EventBean } from '../../../beansts/Event';
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { ActivatedRoute,RouterLink} from '@angular/router';
declare let $: any;
declare var Swal : any;

@Component({
    selector : 'company-login',
    templateUrl:'company-login.html',
})
export class CompanyLoginComponent implements OnInit, OnDestroy{
  public companyLogo="/assets/fixme/logo.png"
  public companyImage="https://www.macmillandictionary.com/us/external/slideshow/full/Grey_full.png"

  public gender='M';
  public avatars=["h1.png","h2.png","h3.png","h4.png","h5.png","h6.png","h7.png","h8.png"]
  public avatarId=0;
  public basicInfoForm
  public loginInfoForm
  public tab=1;
  public company;
  public thumbnail=""

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _routeParams : ActivatedRoute,public _appData : AppDataService,public translate: TranslationService,private fb : FormBuilder, private _companyService : CompanyService) {

    this.loginInfoForm = this.fb.group({
      userEnterEmail: '',
      userEnterPassword:'',
      rememberPass:'',
      lgpdOK:''
    });

  }
    public setTab(tab){
      this.tab=tab;
    }
    public setSex(sex){
      this.gender=sex;
    }

    public ngOnInit(): any {
      this.loginInfoForm = this.fb.group({
        userEnterEmail: '',
        userEnterPassword:'',
        rememberPass:'',
        lgpdOK:''
      });
      this._routeParams.params.subscribe(params => {
        var cid = params.id
        this._companyService.getCompanyById(cid).get().then(v=>{
          this.company=v.data();
          if (typeof window !== "undefined" && localStorage){
            localStorage.setItem('company',JSON.stringify(this.company))
          }
          this.companyImage=this.company.thumbnail
          this.companyLogo=this.company.logo

        })
      });
    }

    public ngOnDestroy() : any {
    }


    public forgetPassword(){
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      if (userEmail==null || userEmail.length==0){
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_11'))
        return;
      }   
      this._companyService.forgetPassword(userEmail).then((val)=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_12'))
      }).catch(err=>{
        Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_13'))
      }     
        );
    }
  
    public loginUserData(){
      let userEmail : string      = this.loginInfoForm.controls['userEnterEmail'].value;
      let userPassword : string = this.loginInfoForm.controls['userEnterPassword'].value;
      let lgpdOk : string = this.loginInfoForm.controls['lgpdOK'].value;

      if (!userEmail || userEmail.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_15'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (userPassword.length<8){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('GAME_USERLOGIN_COMPONENT_16'),
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }


      if (!lgpdOk){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: 'Você não aceitou o LGPD. Por favor baixe e aceite para entrar.',
          confirmButtonColor: '#CFA349',
          confirmButtonText: 'OK'
        })
        return;
      }



      this._companyService.authenticateEmailPassword(userEmail,userPassword).then((result) => {
          let uid=result.user.uid;
          this._companyService.getUserByUid(uid).then((user)=>{
            let myuser=user.data();
            this._appData.profilePicture=myuser.profile_picture;
            if (typeof window !== "undefined" && localStorage){
              localStorage.setItem('instagramUser',JSON.stringify(myuser))
            }
            if (this.company.allCanEnter){
              let domain=window.location.origin
              window.location.replace(domain+"/welcome?1592880902713&room="+this.company.room);   

            }
            else{
              this._companyService.getCompanyWorkers(this.company).doc(uid).get().then(v=>{
                let us=v.data();
                if (!us){
                  Swal.fire({
                    title: this.translate.instant('FAIL'),
                    text: 'Usuário não cadastrado para a empresa',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                  })
                }
                else{
                  us['lgpdAgreed']=true;
                  this._companyService.getCompanyWorkers(this.company).doc(uid).set(us).then(vs=>{
                    let domain=window.location.origin
                    window.location.replace(domain+"/welcome?1592880902713&room="+this.company.room);   
                  })
                }
              })
  
            }

            
              

          }).catch(err=>{
            $('#registerSocialModal').modal('hide')
            Swal.fire({
              title: this.translate.instant('FAIL'),
              text: this.translate.instant('GAME_USERLOGIN_COMPONENT_22'),
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            })
  
          });
        }).catch(err=>{
          $('#registerSocialModal').modal('hide')
            let el=err.code
            if (el.indexOf('wrong-password')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_23'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
              }
            if (el.indexOf('user-not-found')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_24'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
            }
            if (el.indexOf('too-many-requests')>0){
              Swal.fire({
                title: this.translate.instant('FAIL'),
                text: this.translate.instant('GAME_USERLOGIN_COMPONENT_25'),
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
              })
            }
    
  

        });
  
      }
      public registerUserData(){
        let domain=window.location.origin
        window.location.replace(domain+"/register/"+this.company.dbId);   

      }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/company-login/company-login.ts